import { Button, styled, Stack } from "@mui/material";
import React from "react";
import Modal, { CommonModalProps } from "..";
import DropFileZone, { DropFileZoneContext } from "../../Misc/DropFileZone/drop-file-zone";
import { useTranslation } from "react-i18next";

type onCloseClbProps = {
  files: File[];
  success: boolean;
  resourceId: number;
};

export type ModalAddAttachementElementProps = {
  resourceId: number;
  context: DropFileZoneContext;
  onClose?: (props: onCloseClbProps) => void;
};

export type ModalAddAttachementProps = CommonModalProps<ModalAddAttachementElementProps>;

const ModalAddAttachement = React.forwardRef<any, ModalAddAttachementProps>((props, ref) => {
  const { closeModal, onClose, resourceId, context } = props;
  const [uploadSuccess, setUploadSuccess] = React.useState<boolean>(false);
  const [uploadedFiles, setUploadedFiles] = React.useState<File[]>([]);
  const [uploadId, setUploadId] = React.useState<number>(-1);
  const { t } = useTranslation();

  const handleCancelClick: React.MouseEventHandler = () => {
    onClose && onClose({ files: [], success: false, resourceId: -1 });
    closeModal();
  };

  const handleConfirmClick: React.MouseEventHandler = () => {
    onClose && onClose({ files: uploadedFiles, success: true, resourceId: uploadId });
    closeModal();
  };

  const onSuccessUpload = (files: File[], resourceId: number) => {
    setUploadId(resourceId);
    setUploadedFiles(files);
    setUploadSuccess(true);

    console.log("Success upload Id = " + resourceId);
  };

  return (
    <Modal
      title={t("modal:title.addAttachment")}
      reference={ref}
      closeModal={closeModal}
      width={600}
      footer={
        <Stack direction="row" justifyContent="flex-end" spacing={1}>
          <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
          <Button variant="contained" onClick={handleConfirmClick} disabled={!uploadSuccess}>
            {t("common:confirm")}
          </Button>
        </Stack>
      }
    >
      <DropFileZone
        onSuccess={onSuccessUpload}
        dropZoneOptions={{ maxFiles: 1 }}
        context={context}
        resourceId={resourceId}
      />
    </Modal>
  );
});

const FileCard = styled(Stack)(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(1.5)} ${theme.spacing(1)} ${theme.spacing(2)}`,
  border: `1px solid ${theme.palette.backgroundAlpha.border}`,
  borderRadius: 6,
  overflow: "hidden",
}));

export default ModalAddAttachement;
